import React from "react";
import { Pane } from "evergreen-ui";
import { withSize } from "react-sizeme";

export default withSize()(
  ({
    size: { width },
    height = 50,
    widthLimit = 800,
    background,
    partial,
    full
  }) => {
    return (
      <>
        <Pane width="100%" height={height}></Pane>
        <Pane
          width="100%"
          background={background}
          position="fixed"
          top={0}
          left={0}
          zIndex={1}
          height={height}
        >
          {widthLimit > width && partial}
          {widthLimit <= width && full}
        </Pane>
      </>
    );
  }
);
